import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/login");
    }, 1000); // 1 second delay

    return () => clearTimeout(timer); // cleanup agar component unmount ho jaye
  }, [navigate]);

  return (
    <div className="flex items-center justify-center w-full h-[100vh] bg-white">
      <img
        src="/assets/funizzle-logo-zip-file/png/logo-no-background.png"
        alt="Logo"
        className="w-60"
      />
    </div>
  );
};

export default Home;
